import React from 'react';
import { companyInfo } from '../mockData';

const Hero = () => {
  return (
    <section id="home" className="relative h-[600px] flex items-center justify-center">
      {/* Background Image with Overlay */}
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?w=1920&q=80)',
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-gray-900/85 to-gray-900/70"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-4 max-w-4xl mx-auto">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
          Power Up Your Home or Business with {companyInfo.name}
        </h1>
        <p className="text-xl md:text-2xl text-white mb-8">
          Don't trust your property's electricity to just anyone; trust the expertise of Greva Electric.
        </p>
        <a
          href={`tel:${companyInfo.phone}`}
          className="inline-block bg-teal-500 hover:bg-teal-600 text-white font-bold text-lg px-8 py-6 rounded-md transition-all transform hover:scale-105"
        >
          Call For A Free Estimate!
        </a>
      </div>
    </section>
  );
};

export default Hero;